import api from '../../../services/api';

export const budgetService = {
  list: (months: string[]) => api.get('/budgets', { params: { months: months.join(',') } }),
  upsert: (data: { groupId: string; classifierId: string; month: string; amount: number }) =>
    api.post('/budgets', data),
  copy: (fromMonth: string, toMonth: string) => api.post('/budgets/copy', { fromMonth, toMonth }),
};
